module.exports = __webpack_public_path__ + "static/media/jeel-stories.5e3f584d.png";